<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.35 42.66L33.48 16.4a2.06 2.06 0 00-3 0L6.65 42.65A2 2 0 008.13 46h47.74a2 2 0 001.48-3.34zM32 34.1L51.35 43h-38.7zM51.79 41L33 32.36v-12zM31 20.33v12L12.21 41z"/></svg>